module.exports = __webpack_public_path__ + "img/jd23_title.a85b40c1.png";